import React, { useState } from 'react'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { codeOrderManagement as endpoints } from '@URLS'
import { ChangeCourseModal } from './ChangeCourseModal'

export const DetailInfo = ({
  created,
  coursenum,
  orderedCourseTitle,
  numCodes,
  contactName,
  contactEmail,
  institution,
  courseIdentifier,
  comments,
  poNumber,
  price,
  pmtMethod,
  pmtDate,
  txnId,
  invoiceNum,
  invoiceStatus,
  internalNotes,
  orderId,
}) => {
  let [currentState, dispatch] = useStateValue()

  let [showChangeCourse, setShowChangeCourse] = useState(false)

  let [editPrice, setEditPrice] = useState(false)
  let [localPrice, setLocalPrice] = useState(0.0)
  let [priceUpdated, setPriceUpdated] = useState(false)

  let [editPmtDate, setEditPmtDate] = useState(false)
  let [localPmtDate, setLocalPmtDate] = useState('')
  let [dateUpdated, setDateUpdated] = useState(false)

  let [editInvNum, setEditInvNum] = useState(false)
  let [localInvNum, setLocalInvNum] = useState('')
  let [invNumUpdated, setInvNumUpdated] = useState(false)

  let [editInvStatus, setEditInvStatus] = useState(false)
  let [localInvStatus, setLocalInvStatus] = useState('')
  let [invStatusUpdated, setInvStatusUpdated] = useState(false)

  let [editIntNotes, setEditIntNotes] = useState(false)
  let [localIntNotes, setLocalIntNotes] = useState('')
  let [intNotesUpdated, setIntNotesUpdated] = useState(false)

  const formatText = text => {
    if (text) {
      return <b>{text}</b>
    } else {
      return <i className="text-muted">None</i>
    }
  }

  const getEditIconClasses = () => {
    return 'far fa-edit ml-3 pointer'
  }

  const toggleInputEdit = (setter, value) => {
    setter(!value)
  }

  const updateLocalVal = (updater, val, updatedSetter) => {
    updater(val)
    updatedSetter(true)
  }

  const rejectLocalEdit = (setEdit, setLocalVal, val) => {
    setEdit(false)
    setLocalVal(val)
  }

  const updateOrder = async (attrName, value, setFieldFunc, setUpdatedFunc) => {
    let data = {
      orderId: orderId,
      attrName: attrName,
      value: value,
    }
    try {
      let resp = await client.post(endpoints.updateOrder(), data)
      let newOrder = resp.data.order
      let orders = currentState.orders
      for (let i = 0; i < orders.length; i++) {
        if (orders[i] === newOrder.id) {
          orders[i] = newOrder
        }
      }
      dispatch({
        type: 'updateOrders',
        payload: orders,
      })
      dispatch({
        type: 'updateOrder',
        payload: newOrder,
      })
      setFieldFunc(false)
      setUpdatedFunc(false)
    } catch (err) {
      console.error(err)
      toast.error(`There was an error while updating the order data. ${
        err.response.data ? err.response.data.error : err
      }`)
    }
  }

  return (
    <React.Fragment>
      <div className="w-50">
        <table className="ml-3 mr-5">
          <tbody>
            <tr>
              <td className="text-muted text-right">Order date:</td>
              <td className="py-2">&nbsp;&nbsp;&nbsp;{formatText(created)}</td>
            </tr>
            <tr>
              <td className="text-muted text-right">Course number:</td>
              <td className="py-2">
                &nbsp;&nbsp;&nbsp;{formatText(coursenum)} (
                {formatText(orderedCourseTitle)})
                <i
                  className={getEditIconClasses()}
                  title="Change the course for this order"
                  onClick={() => setShowChangeCourse(true)}
                />
              </td>
            </tr>
            <tr>
              <td className="text-muted text-right">Number of Codes:</td>
              <td className="py-2">&nbsp;&nbsp;&nbsp;{formatText(numCodes)}</td>
            </tr>
            <tr>
              <td className="text-muted text-right">Contact name:</td>
              <td className="py-2">
                &nbsp;&nbsp;&nbsp;{formatText(contactName)}
              </td>
            </tr>
            <tr>
              <td className="text-muted text-right">Contact email:</td>
              <td className="py-2">
                &nbsp;&nbsp;&nbsp;{formatText(contactEmail)}
              </td>
            </tr>
            <tr>
              <td className="text-muted text-right">Institution:</td>
              <td className="py-2">
                &nbsp;&nbsp;&nbsp;{formatText(institution)}
              </td>
            </tr>
            <tr>
              <td className="text-muted text-right">Course Identifier:</td>
              <td className="py-2">
                &nbsp;&nbsp;&nbsp;{formatText(courseIdentifier)}
              </td>
            </tr>
            <tr>
              <td className="text-muted text-right">Comments:</td>
              <td className="py-2">&nbsp;&nbsp;&nbsp;{formatText(comments)}</td>
            </tr>
            <tr>
              <td className="text-muted text-right">PO Number:</td>
              <td className="py-2">&nbsp;&nbsp;&nbsp;{formatText(poNumber)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="maxw-50">
        <table>
          <tbody>
            <tr>
              <td
                className="text-muted text-right"
                style={{ whiteSpace: 'nowrap' }}
              >
                Total order cost:
              </td>
              <td className="py-2">
                &nbsp;&nbsp;&nbsp;${formatText(price * numCodes)}
              </td>
            </tr>
            <tr>
              <td className="text-muted text-right">Price:</td>
              {editPrice ? (
                <td className="py-2">
                  &nbsp;&nbsp;&nbsp;$
                  <input
                    type="number"
                    required
                    name="price"
                    onChange={e =>
                      updateLocalVal(
                        setLocalPrice,
                        e.target.value,
                        setPriceUpdated
                      )
                    }
                    defaultValue={price}
                    min="0"
                    step="0.01"
                  />
                  {priceUpdated && (
                    <i
                      className="fa-regular fa-check ml-3 pointer"
                      onClick={() =>
                        updateOrder(
                          'price',
                          localPrice,
                          setEditPrice,
                          setPriceUpdated
                        )
                      }
                    />
                  )}
                  <i
                    className="fa-regular fa-times ml-3 pointer"
                    onClick={() =>
                      rejectLocalEdit(setEditPrice, setLocalPrice, price)
                    }
                  />
                </td>
              ) : (
                <td className="py-2">
                  &nbsp;&nbsp;&nbsp;${formatText(price)}
                  <i
                    className={getEditIconClasses()}
                    onClick={() => toggleInputEdit(setEditPrice, editPrice)}
                  />
                </td>
              )}
            </tr>
            <tr>
              <td
                className="text-muted text-right"
                style={{ whiteSpace: 'nowrap' }}
              >
                Pay type:
              </td>
              <td className="py-2">
                &nbsp;&nbsp;&nbsp;{formatText(pmtMethod)}
              </td>
            </tr>
            <tr>
              <td
                className="text-muted text-right"
                style={{ whiteSpace: 'nowrap' }}
              >
                Transaction ID:
              </td>
              <td className="py-2">&nbsp;&nbsp;&nbsp;{formatText(txnId)}</td>
            </tr>
            <tr>
              <td
                className="text-muted text-right"
                style={{ whiteSpace: 'nowrap' }}
              >
                Pay date:
              </td>
              {editPmtDate ? (
                <td className="py-2">
                  &nbsp;&nbsp;&nbsp;
                  <input
                    type="date"
                    required
                    name="pmtDate"
                    value={localPmtDate}
                    onChange={e =>
                      updateLocalVal(
                        setLocalPmtDate,
                        e.target.value,
                        setDateUpdated
                      )
                    }
                  />
                  {dateUpdated && (
                    <i
                      className="fa-regular fa-check ml-3 pointer"
                      onClick={() =>
                        updateOrder(
                          'payment_date',
                          localPmtDate,
                          setEditPmtDate,
                          setDateUpdated
                        )
                      }
                    />
                  )}
                  <i
                    className="fa-regular fa-times ml-3 pointer"
                    onClick={() =>
                      rejectLocalEdit(setEditPmtDate, setLocalPmtDate, pmtDate)
                    }
                  />
                </td>
              ) : (
                <td className="py-2">
                  &nbsp;&nbsp;&nbsp;{formatText(pmtDate)}
                  <i
                    className={getEditIconClasses()}
                    onClick={() => toggleInputEdit(setEditPmtDate, editPmtDate)}
                  />
                </td>
              )}
            </tr>
            <tr>
              <td
                className="text-muted text-right"
                style={{ whiteSpace: 'nowrap' }}
              >
                Invoice number:
              </td>
              {editInvNum ? (
                <td className="py-2">
                  &nbsp;&nbsp;&nbsp;
                  <input
                    type="number"
                    required
                    name="invoice_number"
                    defaultValue={invoiceNum}
                    min="0.00"
                    onChange={e =>
                      updateLocalVal(
                        setLocalInvNum,
                        e.target.value,
                        setInvNumUpdated
                      )
                    }
                  />
                  {invNumUpdated && (
                    <i
                      className="fa-regular fa-check ml-3 pointer"
                      onClick={() =>
                        updateOrder(
                          'invoice_number',
                          localInvNum,
                          setEditInvNum,
                          setInvNumUpdated
                        )
                      }
                    />
                  )}
                  <i
                    className="fa-regular fa-times ml-3 pointer"
                    onClick={() =>
                      rejectLocalEdit(setEditInvNum, setLocalInvNum, invoiceNum)
                    }
                  />
                </td>
              ) : (
                <td className="py-2">
                  &nbsp;&nbsp;&nbsp;{formatText(invoiceNum)}
                  <i
                    className={getEditIconClasses()}
                    onClick={() => toggleInputEdit(setEditInvNum, editInvNum)}
                  />
                </td>
              )}
            </tr>
            <tr>
              <td
                className="text-muted text-right"
                style={{ whiteSpace: 'nowrap' }}
              >
                Invoice status:
              </td>
              {editInvStatus ? (
                <td className="py-2">
                  &nbsp;&nbsp;&nbsp;
                  <select
                    defaultValue={invoiceStatus}
                    name="invoice_status"
                    onChange={e =>
                      updateLocalVal(
                        setLocalInvStatus,
                        e.target.value,
                        setInvStatusUpdated
                      )
                    }
                  >
                    <option value="Outstanding">Outstanding</option>
                    <option value="Paid">Paid</option>
                    <option value="Voided">Voided</option>
                  </select>
                  {invStatusUpdated && (
                    <i
                      className="fa-regular fa-check ml-3 pointer"
                      onClick={() =>
                        updateOrder(
                          'invoice_status',
                          localInvStatus,
                          setEditInvStatus,
                          setInvStatusUpdated
                        )
                      }
                    />
                  )}
                  <i
                    className="fa-regular fa-times ml-3 pointer"
                    onClick={() =>
                      rejectLocalEdit(
                        setEditInvStatus,
                        setLocalInvStatus,
                        invoiceStatus
                      )
                    }
                  />
                </td>
              ) : (
                <td className="py-2">
                  &nbsp;&nbsp;&nbsp;{formatText(invoiceStatus)}
                  <i
                    className={getEditIconClasses()}
                    onClick={() =>
                      toggleInputEdit(setEditInvStatus, editInvStatus)
                    }
                  />
                </td>
              )}
            </tr>
            <tr>
              <td
                className="text-muted text-right d-flex align-top"
                style={{ whiteSpace: 'nowrap' }}
              >
                Internal Notes:
              </td>
              {editIntNotes ? (
                <td className="">
                  <div className="w-75 pl-3">
                    <textarea
                      name="internal_notes"
                      placeholder="Notes..."
                      defaultValue={internalNotes}
                      onChange={e =>
                        updateLocalVal(
                          setLocalIntNotes,
                          e.target.value,
                          setIntNotesUpdated
                        )
                      }
                      rows="5"
                      cols="50"
                    />
                  </div>
                  {intNotesUpdated && (
                    <i
                      className="fa-regular fa-check ml-3 pointer"
                      onClick={() =>
                        updateOrder(
                          'internal_notes',
                          localIntNotes,
                          setEditIntNotes,
                          setIntNotesUpdated
                        )
                      }
                    />
                  )}
                  <i
                    className="fa-regular fa-times ml-3 pointer"
                    onClick={() =>
                      rejectLocalEdit(
                        setEditIntNotes,
                        setLocalIntNotes,
                        internalNotes
                      )
                    }
                  />
                </td>
              ) : (
                <td className="">
                  <div className="w-75 pl-3">
                    {internalNotes ? formatText(internalNotes) : ''}
                  </div>
                  <i
                    className={getEditIconClasses()}
                    onClick={() =>
                      toggleInputEdit(setEditIntNotes, editIntNotes)
                    }
                  />
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
      <ChangeCourseModal
        show={showChangeCourse}
        close={() => setShowChangeCourse(false)}
        orderId={orderId}
        coursenum={coursenum}
        courseTitle={orderedCourseTitle}
      />
    </React.Fragment>
  )
}
